// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TOY3V","title":"styles_title__L015H"};